import React from 'react';
import { observer } from 'mobx-react-lite';
import { DocumentPreviewStore } from '../../stores';
import { IAppStoreBase, ISessionStoreBase } from '../../types';
import { DocumentVisualStore } from '../../../documents/stores';
import PackageNameLabel from './PackageNameLabel';
import TextSearch from './TextSearch';
import DocumentViewer from './DocumentViewer';
import './FullScreenDocumentPreview.less';

interface Props {
    appStore: IAppStoreBase;
    sessionStore: ISessionStoreBase;
    documentPreviewStore: DocumentPreviewStore;
    documentVisualStore: DocumentVisualStore;
    externalWindow?: Window;
    modelIsLoading?: boolean;
    lightMode?: boolean;
}

const FullScreenDocumentPreview: React.FC<Props> = ({
    appStore,
    sessionStore,
    documentPreviewStore,
    documentVisualStore,
    externalWindow,
    lightMode
}) => {
    if (!externalWindow) {
        console.error('External window is not provided');
        documentPreviewStore.setPreviewPosition('rightSide');
        return null;
    }

    return (
        // Yes, this is not a tab, calcPageWidth in DocumentWithMinimap.tsx requires it to be
        <div id={`tab-content-${appStore.sessionId}`} className="custom-app-full-screen-document-preview">
            <div className="custom-app-document-preview-header">
                <div className="left-container">
                    <PackageNameLabel packageName={appStore.packageName} />
                </div>
                <div className="right-container">
                    <TextSearch variant="filled" documentPreviewStore={documentPreviewStore} lightMode={lightMode} />
                </div>
            </div>

            <div className="custom-app-document-preview-container">
                {documentPreviewStore.showNoResultsMessage && (
                    <span className="no-results-found-message">{DocumentPreviewStore.noResultsFoundMessage}</span>
                )}

                <DocumentViewer
                    defaultScale={0.5}
                    minScale={-1.3}
                    newPageNumberOffset={40}
                    externalWindow={externalWindow}
                    appStore={appStore}
                    sessionStore={sessionStore}
                    documentPreviewStore={documentPreviewStore}
                    documentVisualStore={documentVisualStore}
                    showMinimap
                />
            </div>
        </div>
    );
};

export default observer(FullScreenDocumentPreview);
